import React from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";

import App from "./App";

const Router = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/" component={App} />
        <Route render={() => <h1>404, not found</h1>} />
      </Switch>
    </BrowserRouter>
  );
};

export default Router;
